import script from "./CreateProducto.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateProducto.vue?vue&type=script&setup=true&lang=js"

import "./CreateProducto.vue?vue&type=style&index=0&id=2811cc20&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2811cc20"]])

export default __exports__